import { Skeleton } from '../Skeleton'

interface SkeletonDetailProps {
  fileCount?: number
}

// Mirrors /proofing/[id] chrome:
// back-link (28px) → eyebrow (14px) → big PageHeader title → pip row (28px)
// → action buttons (44px) → file rows. Each file row mirrors `.st-file-row`
// (~70px tall: 12×14 padding + 46px thumb).
export function SkeletonDetail({ fileCount = 4 }: SkeletonDetailProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Skeleton.Bar w={110} h={28} />
      <Skeleton.Bar w={180} h={14} />
      <Skeleton.Bar w="65%" h={56} />
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 4 }}>
        <Skeleton.Bar w={140} h={28} />
        <Skeleton.Bar w={110} h={28} />
        <Skeleton.Bar w={150} h={28} />
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
        <Skeleton.Bar w={120} h={44} />
        <Skeleton.Bar w={140} h={44} />
        <Skeleton.Bar w={160} h={44} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 4 }}>
        {Array.from({ length: fileCount }, (_, i) => (
          <div
            key={i}
            style={{
              border: 'var(--border-w, 2px) solid var(--ink)',
              background: 'var(--paper)',
              boxShadow: 'var(--shadow-sm)',
              padding: '12px 14px',
              display: 'grid',
              gridTemplateColumns: '48px 1fr auto',
              gap: 14,
              alignItems: 'center',
              minHeight: 72
            }}>
            <Skeleton.Box w={48} h={48} />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <Skeleton.Bar w="60%" h={16} />
              <Skeleton.Bar w="35%" h={11} />
            </div>
            <Skeleton.Bar w={56} h={14} />
          </div>
        ))}
      </div>
    </div>
  )
}
